/* eslint-disable camelcase */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import * as jwt from '@/services/jwt'
import store from 'store'
import * as presence from '@/services/presence'

const mapAuthProviders = {
  // firebase: {
  //   login: firebase.login,
  //   register: firebase.register,
  //   currentAccount: firebase.currentAccount,
  //   logout: firebase.logout,
  // },
  jwt: {
    login: jwt.login,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    name: '',
    email: '',
    kodesektor: '',
    sandibpr: '',
    namabpr: '',
    activeSessions: '',
    periode: '',
    KodeJenisPelapor: '',
    cabangList: [],
    permissions: [],
    appList: [],
    defaultApp: {},
    master: {},
    user_branch: '',
    // isAdmin: false,
    showheader: true,
    isHidden: false,
    authorized: process.env.VUE_APP_AUTHENTICATED || false, // false is default value
    loading: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    FRESHLOGIN({ commit, dispatch, rootState }, { payload }) {
      const { username, password, ip } = payload
      commit('SET_STATE', { loading: true })

      const login = mapAuthProviders[rootState.settings.authProvider].login
      login(username, password, ip, true).then((response) => {
        if (response) {
          response.isHidden = response.Hidden
          if (process.env.NODE_ENV === 'development') {
            let apiUrl = process.env.VUE_APP_DEV_URL;
            if (process.env.VUE_APP_PRODUCTION === 'true') {
              apiUrl = process.env.VUE_APP_PROD_URL;
            }
            console.log('original baseurl', response.defaultApp.baseUrl)
            console.log('development mode detected')
            console.log('changing defaultApp baseUrl to local api', apiUrl)
            if (response.defaultApp !== undefined && apiUrl !== undefined) {
              response.defaultApp.baseUrl = apiUrl;
              // also change in appList if exists
              if (response.appList !== undefined && Array.isArray(response.appList)) {
                response.appList = response.appList.map(app => {
                  if (app.id === response.defaultApp.id) {
                    app.baseUrl = apiUrl;
                  }
                  return app;
                });
              }
            }
          }
          dispatch('SET_RESPONSE', { response })
          Vue.prototype.$notification.success({
            message: 'FRESH Logged In',
            description: 'Anda berhasil login ke HEASOFT Banking System!',
            // description: 'Anda berhasil login ke HEASOFT LB-BPRS!',
          })
          dispatch('CONNECT_PRESENCE')
        }
        if (!response) {
          // Vue.prototype.$notification.success({
          //   message: 'Logged In',
          //   description: 'Anda berhasil login ke HEASOFT Banking System!',
          //   // description: 'Anda berhasil login ke HEASOFT LB-BPRS!',
          // })
          // console.log('store->login->gagal')
          commit('SET_STATE', { loading: false })
        }
      })
    },
    LOGIN({ commit, dispatch, rootState }, { payload }) {
      const { username, password, ip } = payload
      commit('SET_STATE', { loading: true })

      const login = mapAuthProviders[rootState.settings.authProvider].login
      login(username, password, ip).then((response) => {
        if (response) {
          dispatch('SET_RESPONSE', { response })
          Vue.prototype.$notification.success({
            message: 'Logged In',
            description: 'Anda berhasil login ke HEASOFT Banking System!',
            // description: 'Anda berhasil login ke HEASOFT LB-BPRS!',
          })
          dispatch('CONNECT_PRESENCE')
        }
        if (!response) {
          // console.log('store->login->gagal')
          commit('SET_STATE', { loading: false })
        }
      })
    },
    SET_RESPONSE({ commit }, { response }) {
      try {
        const {
          name,
          email,
          kodesektor,
          sandibpr,
          namabpr,
          periode,
          master,
          permissions,
          appList,
          defaultApp,
          user_branch,
          showheader,
          cabangList,
          KodeJenisPelapor,
          token,
        } = response
        const isHidden = response.Hidden !== undefined ? response.Hidden === 1 : false
        commit('SET_STATE', {
          name,
          email,
          kodesektor,
          sandibpr,
          namabpr,
          periode,
          master,
          permissions,
          appList,
          defaultApp,
          user_branch,
          cabangList,
          KodeJenisPelapor,
          showheader,
          isHidden,
          authorized: true,
          token,
        })
        localStorage.setItem('userData', JSON.stringify(response))
      } catch (e) {
        // console.log('e', e)
      }
    },
    REGISTER({ commit, dispatch, rootState }, { payload }) {
      // eslint-disable-next-line camelcase
      const {
        name,
        email,
        kodesektor,
        sandibpr,
        namabpr,
        periode,
        master,
        permissions,
        appList,
        defaultApp,
        user_branch,
        showheader,
        cabangList,
        KodeJenisPelapor,
      } = payload
      commit('SET_STATE', { loading: true })

      const register =
        mapAuthProviders[rootState.settings.authProvider].register
      register(
        name,
        email,
        kodesektor,
        sandibpr,
        namabpr,
        periode,
        master,
        KodeJenisPelapor,
        permissions,
        appList,
        defaultApp,
        user_branch,
        showheader,
        cabangList,
      ).then((response) => {
        if (response) {
          dispatch('SET_RESPONSE', { response })
          Vue.prototype.$notification.success({
            message: 'Succesful Registered',
            description: 'You have successfully registered!',
          })
          router.push('/')
        }
        if (!response) {
          commit('SET_STATE', { loading: false })
        }
      })
    },
    // LOAD_CURRENT_ACCOUNT_OLD({ commit, dispatch, rootState }) {
    //   commit('SET_STATE', { loading: false })
    //   const currentAccount =
    //     mapAuthProviders[rootState.settings.authProvider].currentAccount
    //   currentAccount().then((response) => {
    //     // console.log('response', response)
    //     if (response) {
    //       var userData = localStorage.getItem('userData')
    //       if (userData !== undefined || userData !== null) {
    //         var jsoned = JSON.parse(userData)
    //         // console.log('jsoned', jsoned)

    //         try {
    //           if (jsoned.permissions !== undefined) delete jsoned.permissions
    //         } catch (e) {
    //           // console.log('e', e)
    //         }

    //         try {
    //           if (jsoned.appList !== undefined) delete jsoned.appList
    //         } catch (e) {
    //           // console.log('e', e)
    //         }
    //         dispatch('SET_RESPONSE', { response: jsoned })
    //       }
    //     }
    //     commit('SET_STATE', { loading: false })
    //   })
    // },
    LOAD_CURRENT_ACCOUNT({ commit, dispatch, rootState }) {
      commit('SET_STATE', { loading: false })
      const currentAccount =
        mapAuthProviders[rootState.settings.authProvider].currentAccount
      currentAccount().then((response) => {
        // console.log('current account response', response)
        if (response.code !== 200) {
          // route to login
          // console.log('No current account response, routing to login')
          dispatch('EMPTY_STATE')
          dispatch('DISCONNECT_PRESENCE')
          localStorage.removeItem('userData')
          router.push('/auth/login')
        }
      })

      var userData = store.get('userData')
      // console.log('userData from storage', userData)
      if (userData !== undefined || userData !== null) {
        var jsoned = userData // JSON.parse(userData)
        try {
          if (jsoned.permissions !== undefined) delete jsoned.permissions
        } catch (e) {
          // console.log('e', e)
        }

        try {
          if (jsoned.appList !== undefined) delete jsoned.appList
        } catch (e) {
          // console.log('e', e)
        }
        dispatch('SET_RESPONSE', { response: jsoned })
        dispatch('CONNECT_PRESENCE')
      } else {
        console.log('No current account response')
        // NEW: If currentAccount fails (e.g., token invalid), clear state and redirect
        dispatch('EMPTY_STATE')
        localStorage.removeItem('userData')
        router.push('/auth/login')
      }
      commit('SET_STATE', { loading: false })
    },
    EMPTY_STATE({ commit }) {
      commit('SET_STATE', {
        name: '',
        email: '',
        kodesektor: '',
        sandibpr: '',
        namabpr: '',
        periode: '',
        KodeJenisPelapor: '',
        permissions: [],
        appList: [],
        defaultApp: {},
        user_branch: '',
        cabangList: [],
        loading: false,
        isHidden: false,
        showheader: true,
        authorized: false,
        onlineUsers: [],
      })
    },
    CONNECT_PRESENCE({ state }) {
      // const appName = rootState.settings.whatapp ? rootState.settings.whatapp.appName : 'default'
      // const userData = store.get('userData')
      // if (!userData) {
      //   console.log('No user data found for presence connection')
      //   return
      // }
      // const user = { name: userData.name, email: userData.email, token: userData.token }
      const user = { name: state.name, email: state.email, token: state.token, company: state.namabpr, appName: state.defaultApp.appName }

      presence.connectPresence(user)
    },
    DISCONNECT_PRESENCE() {
      presence.disconnectPresence()
    },
    LOGOUT({ commit, dispatch, rootState }) {
      const logout = mapAuthProviders[rootState.settings.authProvider].logout
      logout().then(() => {
        dispatch('DISCONNECT_PRESENCE')
        dispatch('EMPTY_STATE')
        // lou.dropDb()
        localStorage.clear()
        // location.reload()
        // localStorage.removeItem('userData')
        router.push('/auth/login')
      })
    },
  },
  getters: {
    user: (state) => state,
  },
}
